/*const _updateReady = (worker) => {
    // Display a update notif
    console.log('neeew aaaaapp update')
    // if user click refresh
    //worker.postMessage({action: 'skipWaiting'})
}*/

const _trackInstalling = (worker,_updateReady) => {
    worker.addEventListener('statechange', () => {
      if (worker.state === 'installed') {
        _updateReady(worker)
      }
    })
}

export const _registerServiceWorker = (env: string,_updateReady) => {
    console.log('registeeeeeer service worker',env)
    if (!navigator.serviceWorker || env === 'development') return
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').then(reg=>{
            console.log("service worker registration",reg)
            if (!navigator.serviceWorker.controller) return
            let refreshing
            navigator.serviceWorker.addEventListener('controllerchange', () => {
              if (refreshing) return
              window.location.reload()
              refreshing = true
            })
            if (reg.waiting) {
              _updateReady(reg.waiting)
              return
            }
            if (reg.installing) {
              _trackInstalling(reg.installing,_updateReady)
              return
            }
            reg.addEventListener('updatefound', () => {
              _trackInstalling(reg.installing,_updateReady)
            })
            // Ensure refresh is only called once.
            // This works around a bug in "force update on reload".
            setInterval(() => {
              reg.update()
              console.log('Call update SW')
            }, 1000 * 60) // Every minutes TODO Every Hour
            /*navigator.serviceWorker.addEventListener('controllerchange', () => {
              console.log('------------------- controller change triggering',refreshing)
              if (refreshing) return
              window.location.reload()
              refreshing = true
            })*/
        })
        .catch(err=>{
            console.log('registration failed')
        })
    })
}



// WEBPACK FOOTER //
// ./src/utils/ServiceWorker.util.ts